import { LogoViewBoxIcon } from "../../icons/logoDesktopIcon";
import { TextLink } from "../../link/TextLink";
import { useIsPageLoaded } from "../../../../providers/loading-manager/useIsPageLoaded";

export const LogoButton = ({ onClick }: { onClick?: () => void }) => {
  const { isPageLoaded } = useIsPageLoaded();
  const isExternal = !isPageLoaded;

  return (
    <TextLink
      isExternal={isExternal}
      sameTab
      to={isExternal ? "/" : "/#main"}
      onClick={onClick}
    >
      <LogoViewBoxIcon />
    </TextLink>
  );
};
